/**
 * Registro do service worker.
 *
 * Fica fora do `main.tsx` para o arranque da aplicação não depender disso: se
 * o registro falhar — navegador antigo, modo anônimo, HTTP sem TLS — o site
 * continua funcionando igual, só sem instalação e sem cache.
 *
 * Roda depois do `load` de propósito. Registrar durante o carregamento faz o
 * navegador disputar banda entre o service worker e o que a pessoa veio ver.
 */

export function registrarServiceWorker(): void {
  if (!('serviceWorker' in navigator)) return;

  // Em desenvolvimento o service worker atrapalha mais do que ajuda: serve
  // arquivo velho e esconde alteração recém-salva.
  if (import.meta.env.DEV) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {
      // Silêncio proposital: não há nada que o visitante possa fazer a
      // respeito, e o site funciona sem isso.
    });
  });
}
